export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** a date with time */
  LocalDateTime: any;
  /** a very long number: minimum value of 0 and a maximum value of 2^64-1 */
  Long: any;
};

/** Alternativname eines Stoffes oder eines Parameters */
export type Alternativname = {
  __typename?: 'Alternativname';
  /** Name */
  name?: Maybe<Scalars['String']>;
};

/** Anforderung einer Komponente oder eines Parameters */
export type Anforderung = {
  __typename?: 'Anforderung';
  /** Anmerkung der Anforderung */
  anmerkung?: Maybe<Scalars['String']>;
  /** Email der Anforderung */
  email?: Maybe<Scalars['String']>;
  /** Zweck oder Quelle der Anforderung */
  zweckOderQuelle?: Maybe<Scalars['String']>;
};

/**
 * Bezug des Parameters zu den 7 Basisgrößen des Internationalen Größensystems
 *
 * (International System of Quantities, ISQ, ISO 80000 Serie)
 *
 * z.B. Länge, Masse, Zeit.
 */
export type Dimension = {
  __typename?: 'Dimension';
  /** Die Anforderung der Komponente */
  anforderung: Anforderung;
  /** Der Code  (4 Zeichen) */
  code: Scalars['String'];
  /** Datum der letzten Änderung */
  createdDate: Scalars['LocalDateTime'];
  /** Die Datenbank-ID */
  id: Scalars['ID'];
  /** Datum der letzten Änderung */
  lastModifiedDate: Scalars['LocalDateTime'];
  /** Der Name */
  name: Scalars['String'];
  /** Der Status der Komponente */
  status: KomponenteStatus;
  /** Symbol  für die Dimension */
  symbol?: Maybe<Scalars['String']>;
};

/** Dimension query response page */
export type DimensionResponse = {
  __typename?: 'DimensionResponse';
  data?: Maybe<Array<Maybe<Dimension>>>;
  page?: Maybe<ResponsePage>;
};

/** Gibt die zum Parameter verwendete Messgrößeneinheit an, z.B. m³, mg/l. */
export type Einheit = {
  __typename?: 'Einheit';
  /** Die Anforderung der Komponente */
  anforderung: Anforderung;
  /** Der Code  (4 Zeichen) */
  code: Scalars['String'];
  /** Datum der letzten Änderung */
  createdDate: Scalars['LocalDateTime'];
  /** Dimension der Einheit */
  dimension: Dimension;
  /** Die Datenbank-ID */
  id: Scalars['ID'];
  /** ISO-Code der Einheit */
  isocode?: Maybe<Scalars['String']>;
  /** Datum der letzten Änderung */
  lastModifiedDate: Scalars['LocalDateTime'];
  /** Der Name */
  name: Scalars['String'];
  /** Der Status der Komponente */
  status: KomponenteStatus;
  /** Symbol  für die Einheit */
  symbol?: Maybe<Scalars['String']>;
};

/** Einheit query response page */
export type EinheitResponse = {
  __typename?: 'EinheitResponse';
  data?: Maybe<Array<Maybe<Einheit>>>;
  page?: Maybe<ResponsePage>;
};

/** Filter für Komponenten */
export type KomponenteFilter = {
  /**
   * Eine Teilzeichenfolge der Anmerkung der Komponente
   *
   * Filter wird nur verwendet bei den Komponenten
   * Stoff, Matrix, Methode, Nichtstofflich, Probenvorbehandlung, SonstigesKriterium
   */
  anmerkungContains?: InputMaybe<Scalars['String']>;
  /**
   * Eine Teilzeichenfolge der CAS-Nummer der Komponente Stoff
   *
   * Filter wird nur verwendet bei der Komponente Stoff
   */
  casNummerContains?: InputMaybe<Scalars['String']>;
  /** Liste von Komponenten Codes */
  code?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Eine Teilzeichenfolge des Codes der Komponente */
  codeContains?: InputMaybe<Scalars['String']>;
  /**
   * Der Dimensions-Code der Komponente Einheit
   *
   * Filter wird nur verwendet bei der Komponente Einheit
   */
  dimension?: InputMaybe<Scalars['String']>;
  /**
   * Eine Teilzeichenfolge der EG-Nummer der Komponente Stoff
   *
   * Filter wird nur verwendet bei der Komponente Stoff
   */
  euNummerContains?: InputMaybe<Scalars['String']>;
  /**
   * Eine Teilzeichenfolge der Summenformel  der Komponente Stoff
   *
   * Filter wird nur verwendet bei der Komponente Stoff
   */
  formelContains?: InputMaybe<Scalars['String']>;
  /**
   * "Gültig ab" (JJJJ-MM-TT) der Komponente Methode
   *
   * Filter wird nur verwendet bei der Komponente Methode
   */
  gueltigAb?: InputMaybe<Scalars['LocalDateTime']>;
  /**
   * Eine Teilzeichenfolge des ISO-Codes der Komponente Einheit
   *
   * Filter wird nur verwendet bei der Komponente Einheit
   */
  isocodeContains?: InputMaybe<Scalars['String']>;
  /** Der Name der Komponente */
  name?: InputMaybe<Scalars['String']>;
  /** Eine Teilzeichenfolge des Namens der Komponente */
  nameContains?: InputMaybe<Scalars['String']>;
  /**
   * Eine Teilzeichenfolge im Namen oder einem Alternativnamen der Komponente Stoff
   *
   * Filter wird nur verwendet bei der Komponente Stoff
   */
  nameOrAlternativnameContains?: InputMaybe<Scalars['String']>;
  /** Liste von Status der Komponenten */
  status?: InputMaybe<Array<InputMaybe<KomponenteStatus>>>;
  /**
   * Eine Teilzeichenfolge des Symbols der Komponente
   *
   * Filter wird nur verwendet bei den Komponenten Dimension & Einheit
   */
  symbolContains?: InputMaybe<Scalars['String']>;
  /**
   * Eine Teilzeichenfolge des Titels der Komponente Methode
   *
   * Filter wird nur verwendet bei der Komponente Methode
   */
  titelContains?: InputMaybe<Scalars['String']>;
};

/** Status der Komponente */
export enum KomponenteStatus {
  /** Vorgeschlagen */
  Ks1 = 'KS1',
  /** Freigegeben / Aktiv */
  Ks2A = 'KS2A',
  /** Freigegeben / Inaktiv */
  Ks2B = 'KS2B'
}

/**
 * Angabe zur untersuchten Matrix
 *
 * z.B. Wasser, Feststoff (Sediment, Schwebstoffe),
 *
 * Pflanzen, Fisch, Schalentiere, etc.
 */
export type Matrix = {
  __typename?: 'Matrix';
  /** Die Anforderung der Komponente */
  anforderung: Anforderung;
  /** Anmerkung zur Matrix */
  anmerkung?: Maybe<Scalars['String']>;
  /** Der Code  (4 Zeichen) */
  code: Scalars['String'];
  /** Datum der letzten Änderung */
  createdDate: Scalars['LocalDateTime'];
  /** Die Datenbank-ID */
  id: Scalars['ID'];
  /** Datum der letzten Änderung */
  lastModifiedDate: Scalars['LocalDateTime'];
  /** Der Name */
  name: Scalars['String'];
  /** Der Status der Komponente */
  status: KomponenteStatus;
};

/** Matrix query response page */
export type MatrixResponse = {
  __typename?: 'MatrixResponse';
  data?: Maybe<Array<Maybe<Matrix>>>;
  page?: Maybe<ResponsePage>;
};

/** Angabe der Norm für das angewendete Analyseverfahren */
export type Methode = {
  __typename?: 'Methode';
  /** Die Anforderung der Komponente */
  anforderung: Anforderung;
  /** Anmerkung zur Methode */
  anmerkung?: Maybe<Scalars['String']>;
  /** Der Code  (4 Zeichen) */
  code: Scalars['String'];
  /** Datum der letzten Änderung */
  createdDate: Scalars['LocalDateTime'];
  /** Gültig ab diesem Datum */
  gueltigAb: Scalars['LocalDateTime'];
  /** Die Datenbank-ID */
  id: Scalars['ID'];
  /** Datum der letzten Änderung */
  lastModifiedDate: Scalars['LocalDateTime'];
  /** Der Name */
  name: Scalars['String'];
  /** Der Status der Komponente */
  status: KomponenteStatus;
  /** Titel der Methode */
  titel?: Maybe<Scalars['String']>;
};

/** Methode query response page */
export type MethodeResponse = {
  __typename?: 'MethodeResponse';
  data?: Maybe<Array<Maybe<Methode>>>;
  page?: Maybe<ResponsePage>;
};

/**
 * Beschreibende Kenngrößen, die nicht unter die Kategorie Stoff fallen
 *
 * z.B.: physik. Kenngrößen wie pH-Wert, Temperatur, etc.
 *
 * biologische Kenngrößen wie biologische Indices, Zustandsklassen, Toxizität(Algen), etc.
 *
 * weitere deskriptive Kenngrößen wie Färbung, Geruch, etc.
 */
export type Nichtstofflich = {
  __typename?: 'Nichtstofflich';
  /** Die Anforderung der Komponente */
  anforderung: Anforderung;
  /** Anmerkung zur nichtstofflichen Kenngröße */
  anmerkung?: Maybe<Scalars['String']>;
  /** Der Code  (4 Zeichen) */
  code: Scalars['String'];
  /** Datum der letzten Änderung */
  createdDate: Scalars['LocalDateTime'];
  /** Die Datenbank-ID */
  id: Scalars['ID'];
  /** Datum der letzten Änderung */
  lastModifiedDate: Scalars['LocalDateTime'];
  /** Der Name */
  name: Scalars['String'];
  /** Der Status der Komponente */
  status: KomponenteStatus;
};

/** Nichtstofflich query response page */
export type NichtstofflichResponse = {
  __typename?: 'NichtstofflichResponse';
  data?: Maybe<Array<Maybe<Nichtstofflich>>>;
  page?: Maybe<ResponsePage>;
};

/** page query result */
export type Page = {
  /** page start is 1-based, i.e. provide 1 as value for start parameter to request the first page */
  number: Scalars['Int'];
  /** number of records the page should have - minimum 1 */
  size: Scalars['Int'];
};

/** Zentrale Entität des Systems: eigentlich Wasseruntersuchungsparameter */
export type Parameter = {
  __typename?: 'Parameter';
  /** Die Alternativnamen des Parameters */
  alternativnamen?: Maybe<Array<Maybe<Alternativname>>>;
  /** Die Anforderung ddes Parameters */
  anforderung: Anforderung;
  /** Der aus den einzelnen obligatorischen Komponenten-Codes zusammengesetzte Parameter Code. */
  code: Scalars['String'];
  /** Datum der letzten Änderung */
  createdDate: Scalars['LocalDateTime'];
  /** Die Einheit des Parameters */
  einheit: Einheit;
  /** Die eindeutige Datenbank-ID des Parameters */
  id: Scalars['ID'];
  /** Datum der letzten Änderung */
  lastModifiedDate: Scalars['LocalDateTime'];
  /** Die Matrizen des Parameters */
  matrizen?: Maybe<Array<Maybe<Matrix>>>;
  /** Die Methoden des Parameters */
  methoden?: Maybe<Array<Maybe<Methode>>>;
  /** Der Name des Parameters */
  name: Scalars['String'];
  /** Die Nichtstoffliche Kenngrösse des Parameters */
  nichtstofflich?: Maybe<Nichtstofflich>;
  /** Die Probenvorbehandlung des Parameters */
  probenvorbehandlung: Probenvorbehandlung;
  /** Die Sonstigen Kriterien  des Parameters */
  sonstigeKriterien?: Maybe<Array<Maybe<SonstigesKriterium>>>;
  /** Der Status des Parameters */
  status: ParameterStatus;
  /** Der Stoff des Parameters */
  stoff?: Maybe<Stoff>;
};

/** Filter für Parameter */
export type ParameterFilter = {
  /** Liste von Parameter Codes */
  code?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Eine Teilzeichenfolge des Codes */
  codeContains?: InputMaybe<Scalars['String']>;
  /** Der Dimensions-Code */
  dimension?: InputMaybe<Scalars['String']>;
  /** Der Einheit-Code */
  einheit?: InputMaybe<Scalars['String']>;
  /** Ein Matrix-Code */
  matrix?: InputMaybe<Scalars['String']>;
  /** Ein Methode-Code */
  methode?: InputMaybe<Scalars['String']>;
  /** Der Name des Parameters */
  name?: InputMaybe<Scalars['String']>;
  /** Eine Teilzeichenfolge des Namens */
  nameContains?: InputMaybe<Scalars['String']>;
  /** Eine Teilzeichenfolge im Namen oder einem Alternativnamen */
  nameOrAlternativnameContains?: InputMaybe<Scalars['String']>;
  /** Der Nichtstofflich-Code */
  nichtstofflich?: InputMaybe<Scalars['String']>;
  /** Der Probenvorbehandlung-Code */
  probenvorbehandlung?: InputMaybe<Scalars['String']>;
  /** Ein SonstigesKriterium-Code */
  sonstigesKriterium?: InputMaybe<Scalars['String']>;
  /** Liste von Status */
  status?: InputMaybe<Array<InputMaybe<ParameterStatus>>>;
  /** Der Stoff-Code */
  stoff?: InputMaybe<Scalars['String']>;
};

/** Parameter query response page */
export type ParameterResponse = {
  __typename?: 'ParameterResponse';
  data?: Maybe<Array<Maybe<Parameter>>>;
  page?: Maybe<ResponsePage>;
};

/** Parameter Status */
export enum ParameterStatus {
  /** Vorgeschlagen */
  Ps1 = 'PS1',
  /** Freigegeben / Aktiv */
  Ps2A = 'PS2A',
  /** Freigegeben / Inaktiv */
  Ps2B = 'PS2B',
  /** Abgelehnt */
  Ps3 = 'PS3'
}

/**
 * Probenaufbereitung
 *
 * z.B. Gesamtgehalt nach Aufschluss, Gelöster Anteil nach Filtration, keine Probenvorbehandlung, etc.
 */
export type Probenvorbehandlung = {
  __typename?: 'Probenvorbehandlung';
  /** Die Anforderung der Komponente */
  anforderung: Anforderung;
  /** Anmerkung zur Probenvorbehandlung */
  anmerkung?: Maybe<Scalars['String']>;
  /** Der Code  (4 Zeichen) */
  code: Scalars['String'];
  /** Datum der letzten Änderung */
  createdDate: Scalars['LocalDateTime'];
  /** Die Datenbank-ID */
  id: Scalars['ID'];
  /** Datum der letzten Änderung */
  lastModifiedDate: Scalars['LocalDateTime'];
  /** Der Name */
  name: Scalars['String'];
  /** Der Status der Komponente */
  status: KomponenteStatus;
};

/** Probenvorbehandlung query response page */
export type ProbenvorbehandlungResponse = {
  __typename?: 'ProbenvorbehandlungResponse';
  data?: Maybe<Array<Maybe<Probenvorbehandlung>>>;
  page?: Maybe<ResponsePage>;
};

/** Alle verfügbaren Abfragen für EHPC */
export type Query = {
  __typename?: 'Query';
  /** Eine Dimension */
  dimension?: Maybe<Dimension>;
  /** Paginierte Liste von Dimensionen */
  dimensionen?: Maybe<DimensionResponse>;
  /** Ein Parameter */
  einParameter?: Maybe<Parameter>;
  /** Eine Einheit */
  einheit?: Maybe<Einheit>;
  /** Paginierte Liste von Einheiten */
  einheiten?: Maybe<EinheitResponse>;
  /** Eine Matrix */
  matrix?: Maybe<Matrix>;
  /** Paginierte Liste von Matrizen */
  matrizen?: Maybe<MatrixResponse>;
  /** Eine Methode */
  methode?: Maybe<Methode>;
  /** Paginierte Liste von Methoden */
  methoden?: Maybe<MethodeResponse>;
  /** Eine nichtstoffliche Kenngröße */
  nichtstofflich?: Maybe<Nichtstofflich>;
  /** Paginierte Liste von nichtstofflichen Kenngrößen */
  nichtstoffliche?: Maybe<NichtstofflichResponse>;
  /** Paginierte Liste von Parametern */
  parameter?: Maybe<ParameterResponse>;
  /** Eine Probenvorbehandlung */
  probenvorbehandlung?: Maybe<Probenvorbehandlung>;
  /** Paginierte Liste von Probenvorbehandlungen */
  probenvorbehandlungen?: Maybe<ProbenvorbehandlungResponse>;
  /** Paginierte Liste von Sonstigen Kriterien */
  sonstigeKriterien?: Maybe<SonstigesKriteriumResponse>;
  /** Ein Sonstiges Kriterium */
  sonstigesKriterium?: Maybe<SonstigesKriterium>;
  /** Ein Stoff */
  stoff?: Maybe<Stoff>;
  /** Paginierte Liste von Stoffen */
  stoffe?: Maybe<StoffResponse>;
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryDimensionArgs = {
  id: Scalars['ID'];
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryDimensionenArgs = {
  filter?: InputMaybe<KomponenteFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryEinParameterArgs = {
  id: Scalars['ID'];
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryEinheitArgs = {
  id: Scalars['ID'];
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryEinheitenArgs = {
  filter?: InputMaybe<KomponenteFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryMatrixArgs = {
  id: Scalars['ID'];
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryMatrizenArgs = {
  filter?: InputMaybe<KomponenteFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryMethodeArgs = {
  id: Scalars['ID'];
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryMethodenArgs = {
  filter?: InputMaybe<KomponenteFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryNichtstofflichArgs = {
  id: Scalars['ID'];
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryNichtstofflicheArgs = {
  filter?: InputMaybe<KomponenteFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryParameterArgs = {
  filter?: InputMaybe<ParameterFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryProbenvorbehandlungArgs = {
  id: Scalars['ID'];
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryProbenvorbehandlungenArgs = {
  filter?: InputMaybe<KomponenteFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};


/** Alle verfügbaren Abfragen für EHPC */
export type QuerySonstigeKriterienArgs = {
  filter?: InputMaybe<KomponenteFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};


/** Alle verfügbaren Abfragen für EHPC */
export type QuerySonstigesKriteriumArgs = {
  id: Scalars['ID'];
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryStoffArgs = {
  id: Scalars['ID'];
};


/** Alle verfügbaren Abfragen für EHPC */
export type QueryStoffeArgs = {
  filter?: InputMaybe<KomponenteFilter>;
  page?: InputMaybe<Page>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

/** Query response page */
export type ResponsePage = {
  __typename?: 'ResponsePage';
  /** Page number (1-based) */
  number: Scalars['Int'];
  /** Page size */
  size: Scalars['Int'];
  /** Total number of records */
  totalElements: Scalars['Long'];
  /** Total number of pages */
  totalPages: Scalars['Int'];
};

/**
 * Die Parameterkomponente Sonstiges Kriterium beinhaltet mehrere, voneinander unabhängige Parameterausprägungen
 *
 * z.B.: vor Ort Parameter, Probenart, etc.
 */
export type SonstigesKriterium = {
  __typename?: 'SonstigesKriterium';
  /** Die Anforderung der Komponente */
  anforderung: Anforderung;
  /** Anmerkung zu Sonstigem Kriterium */
  anmerkung?: Maybe<Scalars['String']>;
  /** Der Code  (4 Zeichen) */
  code: Scalars['String'];
  /** Datum der letzten Änderung */
  createdDate: Scalars['LocalDateTime'];
  /** Die Datenbank-ID */
  id: Scalars['ID'];
  /** Datum der letzten Änderung */
  lastModifiedDate: Scalars['LocalDateTime'];
  /** Der Name */
  name: Scalars['String'];
  /** Der Status der Komponente */
  status: KomponenteStatus;
};

/** SonstigesKriterium query response page */
export type SonstigesKriteriumResponse = {
  __typename?: 'SonstigesKriteriumResponse';
  data?: Maybe<Array<Maybe<SonstigesKriterium>>>;
  page?: Maybe<ResponsePage>;
};

/** Sort query by one field */
export type Sort = {
  /** sort direction: ASC or DESC */
  direction: SortDirection;
  /** sort field */
  field: Scalars['String'];
};

/** Sort directions */
export enum SortDirection {
  /** Ascending direction */
  Asc = 'ASC',
  /** Descending direction */
  Desc = 'DESC'
}

/**
 * Die Entität Stoff gehört zu den Parameterkomponenten.
 *
 * Stoffe sind chemische Elemente und Verbindungen
 *
 * und davon abgeleitete Indikator- und Summenparameter
 */
export type Stoff = {
  __typename?: 'Stoff';
  /** Alternativnamen des Stoffs */
  alternativnamen?: Maybe<Array<Maybe<Alternativname>>>;
  /** Die Anforderung der Komponente */
  anforderung: Anforderung;
  /** Anmerkung zum Stoff */
  anmerkung?: Maybe<Scalars['String']>;
  /** Die CAS-Nummer des Stoffs (https://de.wikipedia.org/wiki/CAS-Nummer) */
  casNummer?: Maybe<Scalars['String']>;
  /** Der Code des Stoffs (4 Zeichen) */
  code: Scalars['String'];
  /** Datum der letzten Änderung */
  createdDate: Scalars['LocalDateTime'];
  /** Die EG-Nummer des Stoffs (https://de.wikipedia.org/wiki/EG-Nummer) */
  egNummer?: Maybe<Scalars['String']>;
  /** Die Summenformel des Stoffs */
  formel?: Maybe<Scalars['String']>;
  /** Die Datenbank-ID des Stoffs */
  id: Scalars['ID'];
  /** Datum der letzten Änderung */
  lastModifiedDate: Scalars['LocalDateTime'];
  /** Der Name des Stoffs (4 Zeichen) */
  name: Scalars['String'];
  /** Der Status der Komponente */
  status: KomponenteStatus;
};

/** Stoff query response page */
export type StoffResponse = {
  __typename?: 'StoffResponse';
  data?: Maybe<Array<Maybe<Stoff>>>;
  page?: Maybe<ResponsePage>;
};
